export default function preloaderGame4 (scene) {

    scene.load.image(`tilesgame4`, `/tiles/game4.png`);
    scene.load.image(`noLightstickgame4`, `/tiles/noLightstick-game4.png`);

	scene.load.audio("youAndISong", ["/audio/songs/4-youandi.mp3"]);

	scene.load.spritesheet(`jiu-game4`, 
		`/img/game4/jiu.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`sua-game4`, 
		`/img/game4/sua.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`siyeon-game4`, 
		`/img/game4/siyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`handong-game4`, 
		`/img/game4/handong.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`yoohyeon-game4`, 
		`/img/game4/yoohyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`dami-game4`, 
		`/img/game4/dami.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`gahyeon-game4`, //TIENE PROBLEMA CHECAR CON CONA
		`/img/game4/gahyeon.png`,
		{ frameWidth: 27, frameHeight: 37}
	);

	scene.load.spritesheet(`enemy1-game4`, 
		`/img/game4/enemy.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`enemy2-game4`, 
		`/img/game4/enemy3.png`,
		{ frameWidth: 79, frameHeight: 70}
	);

	scene.load.spritesheet(`humo-game4`, 
	`/img/generalSprites/humo-infinite.png`,
	{ frameWidth: 41, frameHeight: 42});

	scene.load.tilemapTiledJSON(`game4`, `/tiles/game4.tmj`);

}